import React, { useMemo, useEffect } from 'react';
import Navbar from './components/Navbar.js';
import DiceRoller from './components/DiceRoller.js';
import Starfield from './components/Starfield.js';
import { WalletProvider as CustomWalletProvider } from './context/WalletContext.js';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from '@solana/web3.js';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';

import './styles/app-layout.css';
import '@solana/wallet-adapter-react-ui/styles.css';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong. Please refresh the page.</h1>;
    }

    return this.props.children;
  }
}

function App() {
  const network = WalletAdapterNetwork.Devnet;
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);
  const wallets = useMemo(
      () => [
          new PhantomWalletAdapter(),
          new SolflareWalletAdapter({ network }),
      ],
      [network]
  );

  useEffect(() => {
    document.body.style.cssText = 'background-color: #000000 !important; margin: 0; padding: 0;';
    document.documentElement.style.cssText = 'background-color: #000000 !important;';
    
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.style.cssText = 'background-color: #000000 !important;';
    }

    // Create a style element
    const style = document.createElement('style');
    style.textContent = `
      body, html, #root, .App {
        background-color: #000000 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <CustomWalletProvider>
            <ErrorBoundary>
              <div className="App" style={{ 
                position: 'relative', 
                minHeight: '100vh', 
                backgroundColor: '#000000 !important',
                color: 'white',
                overflowY: 'auto'
              }}>
                <Starfield />
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <Navbar />
                  <main className="main-content">
                    <div className="game-container">
                      <DiceRoller />
                    </div>
                  </main>
                </div>
              </div>
            </ErrorBoundary>
          </CustomWalletProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;